/* eslint-disable @typescript-eslint/naming-convention */
export enum EUserActionType {
	SIGN_UP = 'signUp',
	LOGIN = 'login',
	LOGOUT = 'logout'
}
